import React, { Component, Fragment, useContext } from 'react';
import { orderBy } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';
import { RuntimeContext } from '../../../../../common/RuntimeContext';
import ManageTable from '../../../components/ManageTable';

import { DEFAULT_IMAGE_URLS } from '../../../../shared/Constants';
import Image from '../../../../shared/components/Image';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';

class CompanyAdminCollectionTable extends Component {
    static propTypes = {
        allCollections: PropTypes.array,
        history: PropTypes.object
    };

    static contextType = RuntimeContext

    _makeColumnRows = () => [
        {
            columnName: 'Actions',
            columnClassName: 'buttonCell',
            columnRowClassName: 'buttonCell',
            columnRowRenderer: (collection) => (
                <Fragment>
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                        fontAwesomeIcon={'fa-eye'}
                        onClick={() => this.props.history.push(`/viewcollection/${collection._id}`)}
                    />
                </Fragment>
            )
        },
        {
            columnName: 'Name',
            columnPropertyName: 'name',
            columnRowRenderer: (collection) => [
                <Image
                    key={`${collection._id}-image`}
                    src={collection.thumbnailImageUrl || DEFAULT_IMAGE_URLS.LEARNING_ASSET_THUMBNAIL_IMAGE}
                    className={'trackCoverImage'}
                    dimension={{ h: 50, w: 50 }}
                    alt={'trackCoverImage'}
                />,
                <a href={`${this.context.pathsWeb.clientUrl}/collection/${collection.permalink}`}>{collection.name}</a>
            ]
        },
        {
            columnName: 'Type',
            columnPropertyName: 'type',
            columnRowRenderer: (collection) => collection.type
        },
        {
            columnName: 'Last Updated On',
            columnPropertyName: 'updatedOn',
            columnRowRenderer: (collection) => moment(collection.updatedOn).format('MMM Do YYYY')
        }
    ];

    selectColumnToSort = (category) => {
        const { sortedLearningAssets } = this.state;
        this.setState({
            sortedLearningAssets: orderBy(sortedLearningAssets, [category, 'name'], ['asc', 'asc'])
        });
    };

    render() {
        const { allCollections } = this.props;
        return (
            <div className={'collection-table'}>
                <div className={'trackListing col-12'}>
                    <ManageTable
                        isStriped={false}
                        isBordered={false}
                        isHover={true}
                        getRowKey={(collection) => collection._id}
                        columnProperties={this._makeColumnRows()}
                        objectArray={allCollections}
                        selectColumnToSort={this.selectColumnToSort}
                    />
                </div>
            </div>
        );
    }
}

export default CompanyAdminCollectionTable;
